<template>
  <preloader />
</template>

<script>
import { mapActions } from 'vuex'
import Preloader from '@/components/Common/Preloader'

export default {
  name: 'ReAuth',
  props: {
    sid: {
      type: String,
      required: true
    }
  },
  components: { Preloader },
  methods: {
    ...mapActions(['attemptLogin', 'clearStore'])
  },
  async mounted () {
    try {
      this.clearStore()
      const response = await this.attemptLogin({ sid: this.sid })
      // this.setSessionReady(true)
      if (response.result === 'success') {
        this.$router.push({ name: 'dashboard' })
      } else {
        this.$router.push({ name: 'login' })
      }
    } catch (e) {
      // TODO Missing API. Fix Authentication Error
      this.$router.push({ name: 'login' })
      console.log(e)
    }
  }
}
</script>
